<template>
<div class="bg-white px-8 py-4 ">
    <lCrumbs :breadcrumb="breadcrumbItems" />
    <lcontainer class="mb-4">
        <div class="heading flex flex-row items-center justify-between py-2 px-8">
            <div>
                <div class="page text-white">Update Course reminder settings</div>
            </div>
            <div>
            </div>
        </div>
    </lcontainer>
    <div v-for="(config, index) in form.course_config" :key="index">
        <div>
            <h2 class="text-center font-bold mb-5">Config {{index + 1}}</h2>

            <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                        Course Progress Start
                    </label>
                    <input v-model="form.course_config[index].course_progress_start" class="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="eg. 10">
                    <p class="text-red-500 text-xs italic">{{errors.course_config}}</p>
                </div>
                <div class="w-full md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                        Course Progress End
                    </label>
                    <input v-model="form.course_config[index].course_progress_end" class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text" placeholder="eg 20">
                    <p class="text-red-500 text-xs italic">{{errors.course_config}}</p>

                </div>

                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                        How Many Days to Reminder
                    </label>
                    <input v-model="form.course_config[index].days_to_reminder" class="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="eg. 10">
                    <p class="text-red-500 text-xs italic">{{errors.course_config}}</p>

                </div>
            </div>
        </div>
        <div class="flex flex-wrap justify-between">
            <p v-if="index > 0" @click="deleteQuestion(index)" class="mx-2 cursor-pointer text-red-500">
                Remove Config
            </p>
        </div>
    </div>
    <div class="flex flex-col justify-center items-center">
        <div class="mb-2">
            <lms-button @click="addQuestion">Add Config</lms-button>
        </div>
    </div>

    <div class="flex flex-col mt-8 justify-center items-center">
        <div class="mb-2">
            <lms-button @click="handleFormSubmit">Update Settings</lms-button>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import FormActions from "@/mixins/FormActions";
import {
    VueEditor
} from "vue2-editor";

export default {
    mixins: [FormActions],
    data() {
        return {
            id: "",
            errors: [],
            form: {
                course_config: [

                    {
                        "course_progress_start": '',
                        "course_progress_end": "",
                        "days_to_reminder": ''
                    },

                ],
            },
            breadcrumbItems: [{
                    disabled: true,
                    to: "/tenant/courses",
                    text: "All Courses ",
                },
                {
                    disabled: true,
                    to: "#",
                    text: "Update Course reminder config",
                },
            ],
        };
    },
    computed: {
        ...mapGetters(["getTenantPrograms"]),
        getPrograms() {
            let programs = this.getTenantPrograms;
            let sortedPrograms = [];
            for (let i = 0; i < programs.length; i++) {
                let temp = {
                    text: programs[i].title,
                    value: programs[i].id,
                };
                sortedPrograms = sortedPrograms.concat(temp);
            }
            return sortedPrograms;
        },
    },
    components: {
        linput: () => import("@/components/general/input"),
        ltextarea: () => import("@/components/general/textarea"),
        LmsButton: () => import("@/components/general/button"),
        lselect: () => import("@/components/forms/select"),
        PageHeader: () => import("@/components/general/pageheader"),
        lcontainer: () => import("@/components/general/container"),
        lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
        VueEditor
    },
    methods: {
        addQuestion() {
            let config = {
                "course_progress_start": '',
                "course_progress_end": "",
                "days_to_reminder": ''
            };
            this.form.course_config.push(config);
        },
        deleteQuestion(index) {
            this.form.course_config.splice(index, 1);
        },

        ...mapMutations(["updateLoader"]),
        ...mapActions(["tenantUpdateCourseReminder", "tenantFetchSingleCourseReminder"]),
        async handleFormSubmit() {
            this.errors = [];
            this.updateLoader(true);
            let res = await this.tenantUpdateCourseReminder(this.form);
            this.updateLoader(false);
            if (res == true || res.status == 200 || res.status == 201) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Reminder Updated successfully",
                });
                this.form = {};
                this.$router.push({
                    name: "tenant-courses"
                });
            } else {
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
    },
    async mounted() {
        this.updateLoader(true);
        let res = await this.tenantFetchSingleCourseReminder({
            id: this.$route.params.id,
        });
        if (res.data.data.course_reminders.length > 1) {
            this.form.course_config = res.data.data.course_reminders;

        }
        // this.form.course_config.forEach((item) => {
        //     if (item.options) {
        //         item.options = JSON.parse(item.options);
        //     }
        // });
        this.form.id = this.$route.params.id;
        this.updateLoader(false);
    },
};
</script>

<style lang="scss" scoped>
.form-row {
    width: 100%;
}

.modal {
    z-index: 10;

    .overlay {
        background: #b1b3b9;
        opacity: 0.89;
        z-index: 0;
    }

    .modal-content {
        width: 100%;
        width: 1001px !important;

        .modal-title {
            font-size: 24px;
            color: color(lms-tenant);
        }

        .modal-field {
            color: color(lms-tenant);
            max-width: calc(135px + 16px);
            width: 100%;
        }

        .close {
            background-color: #c2454b;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            font-size: 12px;
            top: -17px;
            z-index: 2;
            right: -16px;
        }

        z-index: 1;
    }
}
</style>
